import { render } from "./ediPlatform.vue?vue&type=template&id=38509121&lang=true"
import script from "./ediPlatform.vue?vue&type=script&lang=js"
export * from "./ediPlatform.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__